import {createContext, useState, useMemo} from 'react'
import type React from 'react'

import {PLAN_TYPES, type PlanType} from '../../../../brand/components/PlanTypeSegmentedControl/PlanTypeSegmentedControl'

type PlanTypeContextValue = {
  planType: PlanType
  setPlanType: (type: PlanType) => void
}

export const PlanTypeContext = createContext<PlanTypeContextValue>({
  planType: PLAN_TYPES.Individual,
  setPlanType: () => {},
})

type Props = {
  children: React.ReactNode
}

export function PlanTypeContextProvider(props: Props) {
  const {children} = props

  const [planType, setPlanType] = useState<PlanType>(PLAN_TYPES.Individual)

  const contextValue = useMemo(() => ({planType, setPlanType}), [planType])

  return <PlanTypeContext value={contextValue}>{children}</PlanTypeContext>
}
